// extracted by mini-css-extract-plugin
export default {"topContainer":"XMZamd","filterContainer":"Re1sYC","versionPill":"KT5nFW"};